import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import SGTitle from 'components/Typography/SGTitle';
import TextSkeleton from 'components/Skeletons/TextSkeleton';
import {useSiteState} from 'hooks/useSiteInfo/SiteStateProvider';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';

const StyledSwitchHeaderTab = styled.div`
  min-height: 16px;
`;

const StyledSkeleton = styled(TextSkeleton)`
  width: 50rem;
`;

interface SwitchHeaderSubtitleProps {
  siteId: string | undefined;
}

function SwitchHeaderSubtitle({siteId}: SwitchHeaderSubtitleProps) {
  //#region context
  const {state: siteState} = useSiteState();
  //#endRegion context
  const [switchHeaderSubtitle, setSwitchHeaderSubtitle] = useState<string>('');

  useEffect(() => {
    if (siteId && siteState.sites.length > 0) {
      const site: Site | undefined = siteState.sites.find((site: Site) => site.siteId === siteId);

      if (site) {
        setSwitchHeaderSubtitle(`${site.siteCode} ${site.siteName}`);
      } else if (siteId === undefined) {
        setSwitchHeaderSubtitle('');
      } else if (siteState.sites.length > 0) {
        console.error(`Could not find site with siteId ${siteId}`);
        setSwitchHeaderSubtitle(`Invalid Site ${siteId}, please try another location`);
      }
    }
  }, [siteId, siteState]);

  return (
    <StyledSwitchHeaderTab id="header-subtitle">
      {siteId && (
        <SGTitle variant={'t2'} className={'header-title-color'}>
          {switchHeaderSubtitle !== '' ? switchHeaderSubtitle : <StyledSkeleton />}
        </SGTitle>
      )}
    </StyledSwitchHeaderTab>
  );
}

export default SwitchHeaderSubtitle;
